import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { cardShell, pageTitle } from '../app/glass/styles';

const BazaarsComingSoon = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={pageTitle}>{t('bazaars.title')}</div>
      <div
        style={{
          ...cardShell,
          textAlign: 'center',
          padding: isMobile ? '40px 24px' : '64px 48px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: 22,
            display: 'grid',
            placeItems: 'center',
            background: 'rgba(125,1,12,0.18)',
            border: '1px solid rgba(190,50,62,0.35)',
            color: 'var(--red-tx)',
            fontSize: 28,
            fontWeight: 700,
          }}
        >
          SOON
        </div>
        <div style={{ fontSize: isMobile ? 22 : 28, fontWeight: 600, color: 'var(--tx)' }}>
          {t('bazaars.comingSoon')}
        </div>
        <div style={{ fontSize: 14.5, lineHeight: 1.65, color: 'var(--tx2)', maxWidth: 520 }}>
          {t('bazaars.comingSoonDescription')}
        </div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', marginTop: 8 }}>
          <button type="button" className="cz-chip" onClick={() => navigate(-1)}>
            {t('bazaars.goBack')}
          </button>
          <button type="button" className="cz-chip red" onClick={() => navigate('/')}>
            {t('bazaars.backToDashboard')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BazaarsComingSoon;
